/* eslint-disable */
export enum RequestInitiator {
  MMB = 'MMB',
  CHECK_IN = 'CHECK_IN',
  DEEPLINK_MMB = 'DEEPLINK_MMB',
  DEEPLINK_CHECK_IN = 'DEEPLINK_CHECK_IN',
  UNKNOWN = 'UNKNOWN'
}

